import React from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';

class DialogFuelDeliverer extends React.Component {

  constructor(props) {
    super(props);

    const defaultState = {
      name: ''
    };
    this.state = props.detail || defaultState;

    this.inputChangeHandler = this.inputChangeHandler.bind(this);
    this.renderEditField = this.renderEditField.bind(this);
  }

  inputChangeHandler(event) {
    this.setState( { [event.target.name]  : event.target.value } );
  }

  renderEditField(field, title, keyfilter) {
    return (
      <span className="p-float-label dialog-field">
          <InputText name={field} value={this.state[field]}
           onChange={this.inputChangeHandler} keyfilter={keyfilter} />
          <label htmlFor={field}>{title}</label>
      </span>
    )
  }

  render() {
    // ensure required fields
    const { name } = this.state;
    const isValid = name && name.length > 0 ;

    const footer = (
      <div>
        <Button label="Save" icon="pi pi-check" disabled={!isValid}
          onClick={() => this.props.saveFuelDeliverer(this.state)}/>
        <Button label="Cancel" icon="pi pi-times"
          onClick={this.props.onHide} className="p-button-secondary" />
      </div>
    );

    return (
      <div>

        <Dialog
          header="Livreur"
          onHide={this.props.onHide}
          visible={this.props.visible}
          className={"dialog"}
          appendTo={document.body}
          footer={footer}>

          {this.renderEditField('name', 'Name *')}

        </Dialog>

      </div>
    );
  }
}

export default DialogFuelDeliverer
